// Components==============
import React from 'react';
import './index.module.scss';
import useDimensions from 'use-element-dimensions';
// =========================

export default function Container({
    children,
    color,
    image,
    home,
    background,
}) {
    const [{ height }, ref] = useDimensions();

    // console.log(color);
    return (
        <div
            ref={ref}
            styleName={`container ${home ? 'home' : ''} ${
                background ? 'background-asset ' : ''
            } ${image ? 'image-wrapper' : ''} ${color || ''}`}
        >
            {image && (
                <>
                    <img styleName="background-image" src={image} alt={image} />{' '}
                    <div styleName="overlay" />
                </>
            )}
            <div styleName="inner">
                {background && (
                    <div styleName="asset-wrapper">
                        {height > 800 && (
                            <img
                                styleName="top-background-asset"
                                src="/images/asset-dots.svg"
                                alt="background"
                            />
                        )}
                        <img
                            styleName="bottom-background-asset"
                            src="/images/asset-dots.svg"
                            alt="background bottom"
                        />
                    </div>
                )}
                {children}
            </div>
        </div>
    );
}
